const emailjsConfig = {
  serviceID: process.env.REACT_APP_EMAILJS_SERVICE_ID || 'service_0365awt',
  templateID: process.env.REACT_APP_EMAILJS_TEMPLATE_ID || 'template_e7emdhr',
  userID: process.env.REACT_APP_EMAILJS_PUBLIC_KEY || '-LYkayuXVKUY-KNt6',
}

export const hasEmailjsConfig = Object.values(emailjsConfig).every(Boolean)

export default emailjsConfig
